import { useEffect, useState } from 'react';
import { AbsenceSyncSettingsDetail } from '../components/AbsenceSyncSettingsDetail';
import { DirectorySyncSettings } from '../components/DirectorySyncSettings';
import { IntegrationOverview } from '../components/IntegrationOverview';
import { MessagingIntegrationDetail } from '../components/MessagingIntegrationDetail';
import type { IntegrationSettingsRoute } from '../model/types';
import type { IntegrationSettingsPort, IntegrationSettingsRoutePort } from '../port/IntegrationSettingsPort';

export type IntegrationSettingsPageProps = {
  port: IntegrationSettingsPort;
  routePort: IntegrationSettingsRoutePort;
  fixtureMode: boolean;
  canWrite: boolean;
  readOnly: boolean;
  onOpenHolidayCalendars?: () => void;
};

export function IntegrationSettingsPage({
  port, routePort, fixtureMode, canWrite, readOnly, onOpenHolidayCalendars,
}: IntegrationSettingsPageProps) {
  const [route, setRoute] = useState(routePort.read);
  useEffect(() => routePort.subscribe(() => setRoute(routePort.read())), [routePort]);
  const navigate = (next: IntegrationSettingsRoute) => {
    setRoute(next);
    routePort.navigate(next);
  };
  if (route === 'overview') return <IntegrationOverview onOpen={navigate} onOpenHolidayCalendars={onOpenHolidayCalendars} />;
  if (route === 'messaging') return <MessagingIntegrationDetail onBack={() => navigate('overview')} />;
  if (route === 'absence-sync') return <AbsenceSyncSettingsDetail
    port={port} fixtureMode={fixtureMode} canWrite={canWrite} readOnly={readOnly}
    onBack={() => navigate('overview')}
  />;
  return <DirectorySyncSettings
    port={port} fixtureMode={fixtureMode} canWrite={canWrite} readOnly={readOnly}
    route={route} onNavigate={navigate}
  />;
}
